module.exports = [{"title":"после ДТП","id":"is_crashed"},{"title":"кредитный","id":"is_under_loan"},{"title":"продажа в кредит","id":"is_sale_on_credit"},{"title":"нерастаможен","id":"is_not_cleared","isNotCompatibleWithAbroad":true},{"title":"с аукциона","id":"from_auction"},{"title":"новый","id":"is_new","forBusinessUsersOnly":true}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/statuses.json
// module id = 496
// module chunks = 49